var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn is-primary btn-sm btn-block",class:{ 'is-loading': _vm.loading },on:{"click":_vm.approve}},[_vm._v("\n    Godkänn\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }